import { useQuery } from 'react-query';

import {
  ApplicationCount,
  applicationsCountsKey,
  getApplicationsCountsRoute,
} from '@features/applications';
import axiosInstance from '@server/axiosInstance';

type useGetApplicationsCountssProps = {
  query?: string;
};

export const useGetApplicationsCounts = ({
  query,
}: useGetApplicationsCountssProps) => {
  const { data: applicationsCountsData, isLoading: applicationsCountsLoading } =
    useQuery<ApplicationCount[]>({
      queryKey: [applicationsCountsKey, query],
      queryFn: () =>
        axiosInstance
          .get(getApplicationsCountsRoute + `?query=${query}`)
          .then((res) =>
            res.data?.object
              ? (Object.values(res.data.object) as ApplicationCount[])
              : res?.data,
          ),
      refetchOnWindowFocus: false,
    });

  return {
    applicationsCountsData,
    applicationsCountsLoading
  };
};
